import clsx from 'clsx';
import { FC, forwardRef } from 'react';

import ErrorMessage from '@/components/forms/ErrorMessage';

interface Props {
  name: string;
  id?: string;
  classNameContainer?: string;
  labelText: string;
  customClasses?: string;
  otherProps?: any;
  autoComplete?: string;
  placeholder?: string;
  error?: string | undefined;
  value?: string;
  type?: 'text' | 'email';
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const LabelInput: FC<Props> = forwardRef<HTMLInputElement, Props>(
  (
    {
      name,
      id = '',
      classNameContainer = '',
      customClasses = '',
      labelText = '',
      otherProps,
      type = 'text',
      autoComplete,
      placeholder,
      error,
      value,
      onChange,
    },
    ref,
  ) => {
    return (
      <div className={clsx('relative mb-0.5 pb-3.5 md:mb-1 md:pb-5.5', classNameContainer)}>
        <label htmlFor={id} className="text-second-accent text-input-label mb-1 w-fit pb-6">
          {labelText}
        </label>
        <input
          placeholder={placeholder}
          type={type}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          {...otherProps}
          className={clsx(
            'text-input-mobile border-secondary-stroke w-full rounded-md border-[1px] border-solid px-3 py-2 text-black',
            customClasses,
          )}
        />
        {!!error && <ErrorMessage message={error} />}
      </div>
    );
  },
);
